import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "../ui/input";

/**
 * Password input with a show/hide eye toggle.
 *
 * Mirrors the Shadcn `<Input>` API — pass `value`, `onChange`, `placeholder`,
 * `autoComplete`, `data-testid`, etc. The right-side eye button toggles
 * between `type="password"` and `type="text"` without unmounting the field
 * (so caret position is preserved).
 */
export const PasswordInput = ({
  value,
  onChange,
  placeholder,
  autoComplete = "current-password",
  "data-testid": testId = "auth-password-input",
  className = "bg-white border-[#E2E0D8] h-12",
}) => {
  const [shown, setShown] = useState(false);

  return (
    <div className="relative">
      <Input
        value={value}
        type={shown ? "text" : "password"}
        autoComplete={autoComplete}
        onChange={onChange}
        placeholder={placeholder}
        data-testid={testId}
        className={`${className} pr-11`}
      />
      <button
        type="button"
        onClick={() => setShown((s) => !s)}
        aria-label={shown ? "Hide password" : "Show password"}
        data-testid={`${testId}-toggle`}
        className="absolute right-3 top-1/2 -translate-y-1/2 p-1.5 rounded-md text-[#8A93A6] hover:text-[#277A82] hover:bg-[#F1EEE5] transition-colors"
      >
        {shown ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
};

export default PasswordInput;
